import React from 'react';
import { SealCheck, Storefront, Tag, UserCheck } from '@phosphor-icons/react';

import { StatusShell } from '../../design-system/components/shells';
import {
  StatusAction,
  StatusNext,
  StatusNextRow,
} from '../../design-system/patterns/status';
import { routes } from '../../routes/routes';

/**
 * Registration complete, the view. Pure: every input is a prop, every output a
 * callback.
 *
 * This is the SELLER registration outcome. `SellerRegistration.jsx` is the only
 * thing that navigates here, so the copy is a seller's copy: the account exists,
 * verification is pending, and there are three things to do while waiting.
 *
 * WHAT THE OLD PAGE DID THAT THIS DOES NOT
 * ----------------------------------------
 * It was a full landing page: a three-card feature grid, a numbered three-step
 * list and two buttons, on a route the user sees once for about eight seconds.
 * A6 is a splash. The feature grid was marketing on a confirmation screen and
 * is gone; the three steps survive as the "what happens next" lines, which is
 * the same information at the weight it deserves.
 *
 * It also said "your Pokemon cards". This is a trading card game marketplace,
 * not a Pokemon one (README section 9).
 *
 * LIVE BUG FIXED HERE: "Browse Marketplace" called `alert("Redirecting to
 * Marketplace!")` and never navigated. It is a real link now.
 */

export function RegistrationCompleteView({ onGoToDashboard }) {
  return (
    <StatusShell
      tone="success"
      icon={SealCheck}
      title="Your seller account is created"
      description="We are reviewing it now and will email you the moment you are verified. You can set your store up while you wait."
      actions={
        <>
          <StatusAction onClick={onGoToDashboard}>Go to your dashboard</StatusAction>
          <StatusAction to={routes.MARKETPLACE} variant="ghost">
            Browse the marketplace
          </StatusAction>
        </>
      }
    >
      <StatusNext>
        <StatusNextRow icon={UserCheck}>
          We verify your details. Selling opens as soon as that clears.
        </StatusNextRow>
        <StatusNextRow icon={Storefront}>
          Set up your store profile and payout details on your dashboard.
        </StatusNextRow>
        <StatusNextRow icon={Tag}>
          Draft your first listings so they go live the day you are verified.
        </StatusNextRow>
      </StatusNext>
    </StatusShell>
  );
}

export default RegistrationCompleteView;
